export default "__VITE_ASSET__BnuPGaij__"